import React from "react";
import Latex from "react-latex";
import "katex/dist/katex.min.css"; // Required for proper LaTeX styling
import AllDemoQuestions from "../../AllData/AllDemoQuestions";

const Page = () => {
    const questions = AllDemoQuestions;

    // Helper function to render text with LaTeX support
    const renderWithLatex = (text) => {
        if (!text) return null;

        // Check if text contains LaTeX patterns
        if (text.includes('$') || text.includes('\\')) {
            return <Latex>{text}</Latex>;
        }
        return text;
    };

    return (
        <div className="min-h-screen bg-slate-50 py-10 px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto">
                {/* Header */}
                <header className="mb-8 text-center">
                    <h1 className="text-3xl font-extrabold text-slate-900">Practice Questions (DPP)</h1>
                    <p className="text-slate-600 mt-2">Physical World, Units & Measurements</p>
                </header>

                {/* Questions List */}
                <div className="space-y-6">
                    {questions.map((q, index) => {
                        return (
                            <div 
                                key={q._id?.$oid || index} 
                                className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden p-6 transition-all hover:shadow-md"
                            >
                                {/* Subject & Topic Badge */}
                                <div className="flex items-center justify-between mb-4">
                                    <span className="px-3 py-1 text-xs font-semibold uppercase tracking-wider bg-indigo-50 text-indigo-700 rounded-full">
                                        {q.subject} • {q.topic} ({q.topicname})
                                    </span>
                                    <span className="text-xs font-semibold text-slate-400">
                                        Q.{index + 1}
                                    </span>
                                </div>

                                {/* Question Text */}
                                <div className="text-slate-800 font-medium text-lg mb-6 whitespace-pre-line leading-relaxed">
                                    {renderWithLatex(q.question)}
                                </div>

                                {/* Options Grid */}
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
                                    {['option1', 'option2', 'option3', 'option4'].map((optKey, optIdx) => {
                                        const isCorrect = q.answer === optKey;
                                        return (
                                            <div 
                                                key={optKey}
                                                className={`p-3.5 rounded-lg border text-sm transition-all flex items-start gap-3 ${
                                                    isCorrect 
                                                        ? 'border-emerald-500 bg-emerald-50/80 text-emerald-900 font-medium shadow-2xs' 
                                                        : 'border-slate-200 bg-slate-50/40 text-slate-700'
                                                }`}
                                            >
                                                <span className={`inline-flex items-center justify-center w-6 h-6 rounded-full text-xs font-bold shrink-0 ${
                                                    isCorrect ? 'bg-emerald-600 text-white' : 'bg-slate-200 text-slate-700'
                                                }`}>
                                                    {optIdx + 1}
                                                </span>
                                                <div className="flex-1 mt-0.5">
                                                    {renderWithLatex(q[optKey])}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                {/* Correct Answer & Solution */}
                                <div className="border-t border-slate-100 pt-4 mt-4">
                                    <div className="flex items-center gap-2 mb-3">
                                        <span className="text-xs font-bold uppercase tracking-wider text-emerald-700 bg-emerald-100 px-2.5 py-1 rounded">
                                            Correct Answer: {q.answer.replace('option', 'Option ')}
                                        </span>
                                    </div>

                                    
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Page;